const faqItems = [
  {
    q: '八戒电影网是否需要注册才能观看？',
    a: '不需要。八戒电影网坚持开放共享理念，所有影片无需注册登录即可直接在线观看，打开即看，方便快捷。',
  },
  {
    q: '观看影片真的没有广告吗？',
    a: '是的。我们承诺全站无任何形式的贴片广告、弹窗广告或插屏广告，为你提供纯净的观影环境，这也是八戒电影网的核心特色之一。',
  },
  {
    q: '为什么有时候播放会缓冲？',
    a: '八戒电影网采用多线CDN加速和高速服务器，正常网络下播放流畅不缓冲。如遇缓冲，可尝试切换网络或选择较低清晰度播放。',
  },
  {
    q: '支持哪些设备和浏览器？',
    a: '支持主流浏览器（Chrome、Edge、Safari、Firefox）以及手机、平板等移动设备。iOS 和 Android 均可通过浏览器直接访问。',
  },
  {
    q: '影片画质如何？最高支持什么清晰度？',
    a: '平台片库以1080P高清为主，部分热门大片提供4K超清版本。播放器自动根据你的网络环境适配最佳画质，也可手动切换清晰度。',
  },
  {
    q: '如何提交影片资源或反馈问题？',
    a: '可通过页面顶部的「投稿与咨询」板块发送邮件联系我们，或直接添加运营微信 bajiemovie 进行资源投稿和问题反馈。',
  },
];

export default function FAQ() {
  return (
    <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-100">常见问题</h2>
          <p className="text-foreground-500 text-sm mt-2">关于八戒电影网，你想了解的都在这</p>
        </div>
        <div className="space-y-3">
          {faqItems.map((item, i) => (
            <details
              key={i}
              className="group bg-background-100 rounded-xl border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-4 md:p-5 list-none">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-200 pr-4">
                  {item.q}
                </h3>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 text-foreground-500 group-open:rotate-45 transition-transform">
                  <i className="ri-add-line"></i>
                </div>
              </summary>
              <div className="px-4 md:px-5 pb-4 md:pb-5">
                <p className="text-foreground-500 text-sm leading-relaxed">{item.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}